import { DependencyChangeSummary } from '@flowx/designer/modules/ai/types/ai.types'

function parsePackageJson(raw: string | null): Record<string, string> {
  if (!raw) {
    return {}
  }
  try {
    const parsed = JSON.parse(raw)
    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      return parsed
    }
    return {}
  } catch {
    return {}
  }
}

export function computeDependencyChanges(
  currentPackageJson: string | null,
  outcomePackageJson: string | null
): DependencyChangeSummary {
  const current = parsePackageJson(currentPackageJson)
  const outcome = parsePackageJson(outcomePackageJson)
  const added = Object.entries(outcome)
    .filter(([name]) => !(name in current))
    .map(([name, version]) => ({ name, version }))

  const updated = Object.entries(outcome)
    .filter(([name, version]) => name in current && current[name] !== version)
    .map(([name, version]) => ({ name, oldVersion: current[name], newVersion: version }))

  const removed = Object.entries(current)
    .filter(([name]) => !(name in outcome))
    .map(([name, version]) => ({ name, version }))

  return { added, updated, removed }
}
